import React from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import CHero from '../Common/CHero'
import AdmissionBody from './AdmissionBody'

const Admission = () => {
  return (
    <>
    <Nav />
   
    <AdmissionBody />
    <Footer />
    </>
  )
}

export default Admission